"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bomRowDatasheetStatusFieldsSchema = exports.BomRowDatasheetStatus = void 0;
exports.resolveBomRowDatasheetStatus = resolveBomRowDatasheetStatus;
exports.resolveBomReviewRowDatasheetStatus = resolveBomReviewRowDatasheetStatus;
const zod_1 = require("zod");
const package_datasheet_state_1 = require("../PackageStore/package-datasheet-state");
const bom_datasheet_coverage_1 = require("./bom-datasheet-coverage");
const customer_bom_review_grouping_1 = require("./customer-bom-review-grouping");
var BomRowDatasheetStatus;
(function (BomRowDatasheetStatus) {
    BomRowDatasheetStatus["Found"] = "found";
    BomRowDatasheetStatus["Searching"] = "searching";
    BomRowDatasheetStatus["NotFound"] = "not_found";
    BomRowDatasheetStatus["NotApplicable"] = "not_applicable";
    BomRowDatasheetStatus["Dnp"] = "dnp";
    BomRowDatasheetStatus["NotAPart"] = "not_a_part";
    BomRowDatasheetStatus["PartNotIdentified"] = "part_not_identified";
})(BomRowDatasheetStatus || (exports.BomRowDatasheetStatus = BomRowDatasheetStatus = {}));
exports.bomRowDatasheetStatusFieldsSchema = zod_1.z.object({
    datasheetStatus: zod_1.z.nativeEnum(BomRowDatasheetStatus).nullable(),
    datasheetStatusReason: zod_1.z.nativeEnum(package_datasheet_state_1.DatasheetStateReason).nullable(),
    datasheetNextAttemptAt: zod_1.z.date().nullable(),
});
const NO_DATASHEET_STATUS = {
    datasheetStatus: null,
    datasheetStatusReason: null,
    datasheetNextAttemptAt: null,
};
function resolveBomRowDatasheetStatus(input, now) {
    if (input.shownDatasheetFileId !== null) {
        return { ...NO_DATASHEET_STATUS, datasheetStatus: BomRowDatasheetStatus.Found };
    }
    const notApplicableReason = (0, bom_datasheet_coverage_1.resolveDatasheetNotApplicableReason)(input);
    if (notApplicableReason !== null) {
        return {
            ...NO_DATASHEET_STATUS,
            datasheetStatus: notApplicableReason === bom_datasheet_coverage_1.DatasheetNotApplicableReason.Dnp ?
                BomRowDatasheetStatus.Dnp
                : BomRowDatasheetStatus.NotAPart,
        };
    }
    if (input.packageId === null) {
        return { ...NO_DATASHEET_STATUS, datasheetStatus: BomRowDatasheetStatus.PartNotIdentified };
    }
    switch (input.packageDatasheet?.state ?? null) {
        case package_datasheet_state_1.DatasheetState.Searching: {
            const leaseEnd = input.packageDatasheet?.nextAttemptAt ?? null;
            return leaseEnd !== null && leaseEnd.getTime() <= now.getTime() ?
                NO_DATASHEET_STATUS
                : { ...NO_DATASHEET_STATUS, datasheetStatus: BomRowDatasheetStatus.Searching };
        }
        case package_datasheet_state_1.DatasheetState.NotFound:
            return {
                datasheetStatus: BomRowDatasheetStatus.NotFound,
                datasheetStatusReason: input.packageDatasheet?.reason ?? null,
                datasheetNextAttemptAt: input.packageDatasheet?.nextAttemptAt ?? null,
            };
        case package_datasheet_state_1.DatasheetState.NotApplicable:
            return {
                ...NO_DATASHEET_STATUS,
                datasheetStatus: BomRowDatasheetStatus.NotApplicable,
                datasheetStatusReason: input.packageDatasheet?.reason ?? null,
            };
        default:
            return NO_DATASHEET_STATUS;
    }
}
function resolveBomReviewRowDatasheetStatus(group) {
    if ((0, customer_bom_review_grouping_1.resolveBomReviewDatasheetFileId)(group) !== null) {
        return { ...NO_DATASHEET_STATUS, datasheetStatus: BomRowDatasheetStatus.Found };
    }
    const isExempt = (item) => item.datasheetStatus === BomRowDatasheetStatus.Dnp || item.datasheetStatus === BomRowDatasheetStatus.NotAPart;
    const expecting = group.filter((item) => !isExempt(item));
    if (group.length > 0 && expecting.length === 0) {
        return {
            ...NO_DATASHEET_STATUS,
            datasheetStatus: group.some((item) => item.datasheetStatus === BomRowDatasheetStatus.NotAPart) ?
                BomRowDatasheetStatus.NotAPart
                : BomRowDatasheetStatus.Dnp,
        };
    }
    const source = expecting.find((item) => item.datasheetStatus !== null);
    if (source === undefined) {
        return NO_DATASHEET_STATUS;
    }
    return {
        datasheetStatus: source.datasheetStatus,
        datasheetStatusReason: source.datasheetStatusReason,
        datasheetNextAttemptAt: source.datasheetNextAttemptAt,
    };
}
//# sourceMappingURL=bom-row-datasheet-status.js.map